import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../ui-core/Button/Button';
import { IMAGE_CONSTANT, TEXT_CONSTANT } from '../../constants/app';
import { baseURL } from '../../api';
import { getPageName, openLink } from '../../utils/helpers';
import { SEGMENT_EVENTS, trackEvent } from '../../utils/Segment';
import { APP_ROUTES } from '../../route';
import LazyImage from '../../ui-core/Image';
import { useLocation, useParams } from 'react-router';
import { useRoutePattern } from '../../hooks/useRoutePattern';

const GoogleLogin = ({ isLoading, section, plan_id }) => {
  const location = useLocation();
  const params = useParams();
  const routePattern = useRoutePattern();
  const isLogin = section === 'Login';
  const handleRedirection = () => {
    const isChallegnesPage = routePattern === APP_ROUTES.COURSE_SLUG;
    const slug = params.slug;
    const page = isChallegnesPage ? slug : getPageName(location.pathname);
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      page: page,
      section_title: section,
      button_title: 'Sign up with Gmail',
    });
    openLink(
      baseURL +
        '/auth/google_oauth2?page=' +
        encodeURI(page) +
        (plan_id ? `&plan_id=${plan_id}` : ''),
      true,
    );
  };
  return (
    <Button
      text={
        <div className="d-flex justify-content-center align-items-center">
          <LazyImage
            alt={IMAGE_CONSTANT.googleIcon}
            className="img-fluid mx-2"
            errorSrc={IMAGE_CONSTANT.placeholderImage}
            placeholderSrc={IMAGE_CONSTANT.placeholderImage}
            src={IMAGE_CONSTANT.googleIcon}
          />
          <span className="social_text">
            {/* {isLogin
              ? TEXT_CONSTANT.LOGIN_WITH_GOOGLE
              : TEXT_CONSTANT.SIGNUP_WITH_GOOGLE} */}

            {isLogin ? 'GOOGLE' : TEXT_CONSTANT.SIGNUP_WITH_GOOGLE}
          </span>
        </div>
      }
      class="sign-with-button"
      isDisabled={isLoading}
      isLoading={isLoading}
      onClick={handleRedirection}
    ></Button>
  );
};

GoogleLogin.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  section: PropTypes.string.isRequired,
  plan_id: PropTypes.string,
};

export default GoogleLogin;
